import { memo } from "react";
import { sanitizeImageUrl } from "../../../utils/sanity.utils";
import { ListItem } from "../../../model/info-about-bootcamp";

interface Props {
  feature: ListItem;
}

export const Details = memo<Props>(({ feature }) => {
  return (
    <>
      <div className="rounded-[20px] bg-night-background p-10 lg:p-12 text-white mb-6 lg:mb-0">
        <img
          className="w-[42px]"
          src={feature.image && sanitizeImageUrl(feature.image.asset._ref)}
          alt={`${feature.title} image`}
        />
        <div
          className="pt-8 max-w-[250px] lg:max-w-full"
          // eslint-disable-next-line
          dangerouslySetInnerHTML={{
            __html: feature.title,
          }}
        />
      </div>
    </>
  );
});
